module.exports = {"540529100":"隆子镇","540529101":"日当镇","540529200":"加玉乡","540529201":"列麦乡","540529202":"热荣乡","540529203":"三林乡","540529204":"准巴乡","540529205":"斗玉珞巴民族乡","540529206":"雪沙乡","540529207":"扎日乡","540529208":"玉麦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540529.json
// module id = 2536
// module chunks = 0